module.exports = __webpack_public_path__ + "static/media/GML_dark.104e7a48.png";